import * as R from 'ramda';
import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// feature public-clo
import * as A from './actions';
//////////////////////////////////////////////////

const initialState = {
  totalCount: 0,
  loading: false,
  itemList: null,
  filterProps: [],
  usedReport: null,
  reportPending: false,
  globalFilterValue: '',
  availableReports: null,
  pagination: {
    limit: 15,
    offset: 0,
  },
};

const setInitialState = () => initialState;

const setReportPending = (state) => P.$set('reportPending', true, state);

const setFilterProps = (state, data) => P.$set('filterProps', data, state);

const setListLoading = (state, loading) => P.$set('loading', loading, state);

const setReports = (state, reports) => P.$set('availableReports', reports, state);

const resetListAndPagination = (state) => (
  P.$all(
    P.$set('totalCount', 0),
    P.$set('itemList', null),
    P.$set('pagination', initialState.pagination),
    state,
  )
);

const setUsedReport = (state, data) => (
  P.$all(
    P.$set('totalCount', 0),
    P.$set('itemList', null),
    P.$set('usedReport', data),
    P.$set('reportPending', false),
    P.$set('globalFilterValue', ''),
    P.$set('pagination', initialState.pagination),
    state,
  )
);

const setUsedReportOnly = (state, data) => (
  P.$all(
    P.$set('usedReport', data),
    P.$set('globalFilterValue', ''),
    state,
  )
);

const getReportListSuccess = (state, data) => {
  if (R.equals(data.totalCount, 0)) return state;
  const { itemList, pagination } = state;
  const indexAdditional = R.length(R.values(itemList));
  const newItems = data.results.map((item, i) => R.mergeRight(
    item,
    {
      selected: false,
      index: R.add(i, indexAdditional),
    },
  ));
  const list = R.mergeRight(itemList, R.indexBy(R.prop(GC.FIELD_GUID), newItems));
  const newOffset = R.add(pagination.offset, pagination.limit);

  return P.$all(
    P.$set('itemList', list),
    P.$set('totalCount', data.totalCount),
    P.$set(
      'pagination.offset',
      G.ifElse(
        R.gt(data.totalCount, newOffset),
        newOffset,
        data.totalCount,
      ),
    ),
    state,
  );
};

const selectItem = (state, data) => {
  const { itemList } = state;
  if (R.equals(data, 'all')) {
    const value = R.not(R.all(
      (item) => item.selected,
      R.values(itemList),
    ));

    return P.$set(
      'itemList',
      R.map(
        (item) => R.assoc('selected', value, item),
        itemList,
      ),
      state,
    );
  }

  return P.$toggle(`itemList.${data}.selected`, state);
};

const setGlobalFilterValue = (state, data) => (
  P.$set('globalFilterValue', data, state)
);

const setCloLoadFromEDIStatus = (state, { transactionGuid, status }) => (
  P.$set(`itemList.${transactionGuid}.${GC.FIELD_CLO}.${GC.FIELD_STATUS}`, status, state)
);

export default createReducer({
  [A.setReports]: setReports,
  [A.selectItem]: selectItem,
  [A.setUsedReport]: setUsedReport,
  [A.setFilterProps]: setFilterProps,
  [A.setListLoading]: setListLoading,
  [A.setInitialState]: setInitialState,
  [A.setReportPending]: setReportPending,
  [A.setUsedReportOnly]: setUsedReportOnly,
  [A.setGlobalFilterValue]: setGlobalFilterValue,
  [A.getReportListSuccess]: getReportListSuccess,
  [A.resetListAndPagination]: resetListAndPagination,
  [A.setCloLoadFromEDIStatus]: setCloLoadFromEDIStatus,
}, initialState);
